import { Button } from "@mui/material"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { followManager, getFollowingList } from "../../controllers/accounts/accounts"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

export const FollowAccountManager = ({auth_id, id, token}) => {
    const { data:following } = useQuery({ queryKey: ['getFollowingList'], queryFn: () => getFollowingList(id=auth_id, token) })
    const [followingList, setFList] = useState([])
    const [isFollowing, setIsFollowing] = useState(false)
    
    useEffect(() => {
        if(following?.length > 0){
            following?.filter(item => setFList(followingList => [...followingList, item.id]))
        }
    }, [following])

    useEffect(() => {
        setIsFollowing(followingList?.includes(id))
    }, [followingList, id])
    

    const queryClient = useQueryClient()
    const mutation = useMutation({
        mutationFn: followManager,
        onSuccess: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries({ queryKey: ['getFollowingList'] })
        setIsFollowing(!isFollowing)
        },
    })

    const send_follow = () => {
        mutation.mutate({
            token, 
            follow: isFollowing ? false : true, 
            id
        })
    }
    
    return (
        <Button onClick={send_follow} variant="contained" color={isFollowing ? 'error' : 'secondary'} style={{marginRight:"5px", marginBottom:"5px"}}>{isFollowing ? 'UnFollow' : 'Follow'}</Button>
    )
}

// Hands off to the same "New Message" flow used from the conversation list
// (relationship check, direct/public fallback, and — crucially — registering
// the new thread with the sidecar so it actually shows up under Messages)
// instead of composing inline here, which used to post straight to Mastodon
// with no sidecar registration and silently never appear anywhere.
export const MessageUser = ({account}) => {
    const navigate = useNavigate()

    return (
        <Button
            onClick={() => navigate('/messages/create', { state: { prefillAccount: account } })}
            variant="contained"
            color="info"
            style={{marginBottom:"5px"}}
        >
            Message
        </Button>
    )
}